/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 67018999d72f
 */

import * as z from "zod";
import {
  AssetRelationInfo,
  AssetRelationInfo$zodSchema,
} from "./assetrelationinfo.js";

export type AssetRelationsDeleteResponse = {
  failed?: Array<AssetRelationInfo> | undefined;
  success?: Array<AssetRelationInfo> | undefined;
};

export const AssetRelationsDeleteResponse$zodSchema: z.ZodType<
  AssetRelationsDeleteResponse
> = z.object({
  failed: z.array(AssetRelationInfo$zodSchema).optional(),
  success: z.array(AssetRelationInfo$zodSchema).optional(),
});
